(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-videos"] && !Shopify.designMode) return;
  try {
    
  class CreatorVideos extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-creator-video-open]'));
      this.templates = this.cards.map((card) => this.querySelector(`[data-creator-video-template="${card.dataset.creatorVideoOpen}"]`));
      this.modal = this.querySelector('.creator-videos__modal');
      this.dialog = this.querySelector('.creator-videos__dialog');
      this.closeButton = this.querySelector('.creator-videos__close');
      this.previousButton = this.querySelector('.creator-videos__arrow--prev');
      this.nextButton = this.querySelector('.creator-videos__arrow--next');
      this.activeIndex = 0;

      this.cards.forEach((card, index) => {
        card.addEventListener('click', () => this.open(index));
      });
      this.closeButton?.addEventListener('click', () => this.close());
      this.previousButton?.addEventListener('click', () => this.show(this.activeIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.activeIndex + 1));
      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.close();
      });
      document.addEventListener('keydown', (event) => {
        if (!this.modal || this.modal.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.show(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.show(this.activeIndex + 1);
      });

      if (this.dataset.autoplay === 'true') this.playVisiblePreviews();
    }

    playVisiblePreviews() {
      const videos = Array.from(this.querySelectorAll('.creator-videos__video'));
      videos.forEach((video) => {
        video.muted = true;
        video.play?.().catch(() => {});
      });
    }

    open(index) {
      if (!this.modal || !this.dialog) return;
      this.modal.hidden = false;
      document.documentElement.classList.add('creator-videos-open');
      this.show(index);
    }

    show(index) {
      if (!this.templates.length || !this.dialog) return;
      this.activeIndex = (index + this.templates.length) % this.templates.length;
      const template = this.templates[this.activeIndex];
      if (!template) return;
      this.dialog.replaceChildren(template.content.cloneNode(true));
      const video = this.dialog.querySelector('video');
      if (video) video.play?.().catch(() => {});
    }

    close() {
      if (!this.modal || !this.dialog) return;
      this.modal.hidden = true;
      this.dialog.replaceChildren();
      document.documentElement.classList.remove('creator-videos-open');
      this.playVisiblePreviews();
    }
  }

  if (!customElements.get('creator-videos')) {
    customElements.define('creator-videos', CreatorVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
